import React from "react";
import { Link, Box, Typography } from "@mui/material";
import { useCourse } from "../../pages/course/hooks";
import StandardCard from './StandardCard';

export function CourseCard({ course }) {
    const editLink = `/courses/edit/${course.id}`;
    const lessonIcon = `/courses/${course.id}/lesson-plan`

    const { remove } = useCourse()
    // const badgeStyles = course.courseStatus?.toLowerCase() === "active" ? styles.badgeGreen : styles.badgeOrange;

    const onDelete = () => {
        if (!confirm('Are you sure to delete this course?')) { return; }

        remove({ id: course.id });
    }

    return (
        <Box>
            <StandardCard
                data={course}
                onDelete={onDelete}
                editCourse={editLink}
                lessonIcon={lessonIcon}
            />
        </Box>

    );
}

const styles = {
    courseDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginTop: '15px',
    },
    detailItem: {
        marginBottom: '10px',
    },
    itemHeading: {
        // backgroundColor: 'var(--mui-palette-primary-blue)',
        color: 'var(--mui-palette-primary-blue)',
        fontSize: '0.8rem',
        fontWeight: 600,
        marginBottom: '5px',
        // marginLeft: '-15px',
        // padding: '9px 15px',
        // width: '80px',
        // display: 'inline-block',
        // borderRadius: '0 20px 20px 0',
    },
    itemValue: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '0.9rem',
        minHeight: '32px'
    },
    badge: {
        padding: '6px 10px',
        backgroundColor: 'var(--mui-palette-primary-orange)',
        marginRight: '1rem',
        borderRadius: '6px',
        fontSize: '.7rem',
        fontWeight: '600',
        letterSpacing: '0.5px'
    },
    badgeGreen: {
        backgroundColor: 'var(--mui-palette-primary-dark)',
        color: 'var(--mui-palette-common-white)',
    },
    badgeOrange: {
        color: 'var(--mui-palette-common-white)',
        backgroundColor: 'var(--mui-palette-primary-orange)',
    },
    actionBtn: {
        textAlign: 'right',
        position: 'absolute',
        top: '10px',
        right: '5px',
        padding: '5px',
        display: 'flex'
    },
    actionBtnItem: {
        marginLeft: '5px',
        marginRight: '5px',
        cursor: 'pointer'
    }
};

export default CourseCard;
